module.exports = __webpack_public_path__ + "static/media/datazip-text-logo.7a3a7d0f.svg";